/*
 # Tabs
 # Subscriptions app enhancements
 # Function to hide an element by ID if the URL matches a pattern
 # Dynamic price update functionality
 # Tooltip functionality
 # Desktop hover dropdown for header menu
 # Hide specific classes on the page
 */

// # Tabs
document.addEventListener('DOMContentLoaded', () => {
  const tabSections = document.querySelectorAll('section [class*="tabs-section--"]');

  if (tabSections.length > 0) {
    tabSections.forEach((section, idx) => {
      section.style.display = idx === 0 ? 'block' : 'none';
    });
  }

  const tabButtons = document.querySelectorAll('.tabs-buttons span');

  tabButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      tabButtons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      tabSections.forEach((section) => (section.style.display = 'none'));

      const sectionClass = btn.getAttribute('data-section');
      const target = document.querySelector(`section .${sectionClass}`);
      if (target) target.style.display = 'block';

      // Show/hide children tab sections based on parent tab selection
      const childTabSections = document.querySelectorAll('section [class*="tabs-section-children--"]');
      const childTabButtons = document.querySelectorAll('.tabs-buttons-children span');
      
      if (sectionClass && sectionClass.includes('faq')) {
        // Show first children tab section and activate first children tab button
        if (childTabSections.length > 0) {
          childTabSections.forEach((section, idx) => {
            section.style.display = idx === 0 ? 'block' : 'none';
          });
        }
        if (childTabButtons.length > 0) {
          childTabButtons.forEach((b, idx) => b.classList.toggle('active', idx === 0));
        }
      } else {
        // Hide all children tab sections and deactivate all children tab buttons
        if (childTabSections.length > 0) {
          childTabSections.forEach((section) => {
            section.style.display = 'none';
          });
        }
        if (childTabButtons.length > 0) {
          childTabButtons.forEach((b) => b.classList.remove('active'));
        }
      }
    });
  });

  // Child tabs functionality: hide all children tab sections on load
  const childTabSections = document.querySelectorAll('section [class*="tabs-section-children--"]');
  
  if (childTabSections.length > 0) {
    childTabSections.forEach((section) => {
      section.style.display = 'none';
    });
  }

  const childTabButtons = document.querySelectorAll('.tabs-buttons-children span');

  childTabButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      childTabButtons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      childTabSections.forEach((section) => (section.style.display = 'none'));

      const sectionClass = btn.getAttribute('data-section');
      const target = document.querySelector(`section .${sectionClass}`);

      if (target) target.style.display = 'block';
    });
  });

  // FAQ search functionality
  const faqSearchInput = document.querySelector('.faq-search input');
  
  if (faqSearchInput) {
    faqSearchInput.addEventListener('input', () => {
      const query = faqSearchInput.value.trim().toLowerCase();

      document.querySelectorAll('section [class*="tabs-section--"] .accordion').forEach((accordion) => {
        const content = accordion.textContent.toLowerCase();
      
        accordion.style.display = content.includes(query) ? 'block' : 'none';
      });
    });
  }
})

// # Subscriptions app enhancements
const sections = document.querySelectorAll(
  'section.shopify_subscriptions_app_block'
)

sections.forEach((section) => {
  const radioButtons = section.querySelectorAll(
    'input[data-radio-type="selling_plan"]'
  )

  if (radioButtons.length > 0) {
    radioButtons[radioButtons.length - 1].checked = true
  }

  section.style.display = 'none'
})

// Select the parent element to observe
const parentElement = document.querySelector('.shopify-app-block')

// Function to check conditions and update button text
const updateButtonText = () => {
  const blocks = document.querySelectorAll('.shopify_subscriptions_app_block')
  const hidden = Array.from(blocks).every((block) =>
    block.classList.contains('shopify_subscriptions_app_block--hidden')
  )

  const button = document.querySelector('.product-form__buttons button span')
  const disabledInput = document.querySelector('input.disabled')

  if (button) {
    if (disabledInput) {
      button.textContent = 'Sold Out'
    } else if (!hidden) {
      button.textContent = 'Checkout'
    }
  }
}


if (parentElement) {
  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const targetElement = mutation.target
        if (
          targetElement.classList.contains(
            'shopify_subscriptions_app_block--hidden'
          )
        ) {
          updateButtonText()
        }
      }
    }
  })

  observer.observe(parentElement, { attributes: true, subtree: true })
}

// Update button text on page load
document.addEventListener('DOMContentLoaded', updateButtonText)

// # Function to hide an element by ID if the URL matches a pattern
const hideElementOnMatch = (urlPattern, elementId) => {
  const currentUrl = window.location.href

  if (currentUrl.includes(urlPattern)) {
    const element = document.getElementById(elementId)

    if (element) {
      element.style.display = 'none'
    }
  }
}

// Common part of the element IDs
const commonElementId =
  'shopify-section-template--18095533326590__custom_liquid'

// Array of URL patterns and corresponding unique parts of element IDs
const elementsToHide = [
  { urlPattern: '/daily-replenisher', uniqueId: 'hDnMVY' },
  { urlPattern: '/daily-replenisher', uniqueId: 'XXPBC4' },
  { urlPattern: '/daily-replenisher', uniqueId: 'pGnEqp' },
  { urlPattern: '/replenza-bundle', uniqueId: 'XFRxrA' },
  { urlPattern: '/replenza-bundle', uniqueId: 'XXPBC4' },
  { urlPattern: '/replenza-bundle', uniqueId: 'pGnEqp' },
  { urlPattern: '/daily-nutritional-supplement', uniqueId: 'XFRxrA' },
  { urlPattern: '/daily-nutritional-supplement', uniqueId: 'hDnMVY' },
  { urlPattern: '/daily-nutritional-supplement', uniqueId: 'fJaHAC' },
]

// Loop through the array and hide elements if the URL matches
if (elementsToHide.length > 0) {
  elementsToHide.forEach(({ urlPattern, uniqueId }) => {
    const fullElementId = `${commonElementId}_${uniqueId}`

    hideElementOnMatch(urlPattern, fullElementId)
  })
}

// # Dynamic price update functionality
document.addEventListener('DOMContentLoaded', () => {
  let currentType = 'Subscription'

  const updatePrices = () => {
    // Get selected type or use tracked value
    const selectedType =
      document.querySelector('input[name*="Type"]:checked')?.value ||
      currentType
    if (selectedType !== currentType) currentType = selectedType

    // Update all price elements
    document.querySelectorAll('.supply-price').forEach((el) => {
      const { regularPrice, salePrice } = el.dataset
      if (!regularPrice || !salePrice) return

      const newContent =
        selectedType === 'Subscription'
          ? `${salePrice}<span class="price">${regularPrice}</span>`
          : regularPrice

      if (el.innerHTML.trim() !== newContent.trim()) {
        el.innerHTML = newContent
      }
    })
  }

  // Handle all price updates with a single debounced function
  const debouncedUpdate = (() => {
    let timeout
    return (delay = 25) => {
      clearTimeout(timeout)
      timeout = setTimeout(updatePrices, delay)
    }
  })()

  // Listen for type changes
  document.addEventListener('change', (e) => {
    if (e.target.name?.includes('Type')) {
      currentType = e.target.value
      updatePrices()
    }
  })

  // Listen for variant changes (pub/sub and DOM mutations)
  if (typeof subscribe === 'function') {
    subscribe('option-value-selection-change', () => debouncedUpdate(50))
  }

  new MutationObserver((mutations) => {
    if (
      mutations.some((m) =>
        Array.from(m.addedNodes).some(
          (n) =>
            n.nodeType === 1 &&
            (n.matches?.('variant-selects') ||
              n.querySelector?.('variant-selects'))
        )
      )
    ) {
      debouncedUpdate()
    }
  }).observe(document.body, { childList: true, subtree: true })

  // Initial update
  debouncedUpdate()
})

// # Tooltip functionality
document.addEventListener('DOMContentLoaded', () => {
  const iconElement = document.querySelectorAll('.product .icon-with-text')

  iconElement.forEach((icon) => {
    icon.addEventListener('mouseenter', showTooltip)
    icon.addEventListener('mouseleave', hideTooltip)
    icon.addEventListener('touchstart', toggleTooltip)
  })

  function showTooltip(event) {
    const icon = event.currentTarget

    if (icon._tooltip) {
      return
    }

    const tooltipContent = icon.nextElementSibling

    if (tooltipContent && tooltipContent.classList.contains('product__text')) {
      const tooltip = document.createElement('div')

      tooltip.className = 'product-tooltip'
      tooltip.innerHTML = tooltipContent.innerHTML

      if (!icon._learnMoreClicked) {
        const learnMore = document.createElement('span')

        learnMore.textContent = 'Learn More...'
        learnMore.className = 'learn-more'
        learnMore.addEventListener('click', (e) => {
          e.stopPropagation()

          const nextTooltipContent = tooltipContent.nextElementSibling

          if (
            nextTooltipContent &&
            nextTooltipContent.classList.contains('product__text')
          ) {
            tooltipContent.innerHTML = nextTooltipContent.innerHTML
            tooltip.innerHTML = tooltipContent.innerHTML
            tooltip.appendChild(learnMore)
            icon._learnMoreClicked = true
            learnMore.style.display = 'none'
          }
        })

        tooltip.appendChild(learnMore)
      }

      document.body.appendChild(tooltip)

      const iconRect = icon.getBoundingClientRect()

      tooltip.style.position = 'absolute'
      tooltip.style.top = `${iconRect.bottom + window.scrollY}px`
      tooltip.style.left = `${iconRect.left + window.scrollX}px`

      icon._tooltip = tooltip

      tooltip.addEventListener('mouseenter', () => {
        icon._tooltipVisible = true
      })
      tooltip.addEventListener('mouseleave', () => {
        icon._tooltipVisible = false
        hideTooltip({ currentTarget: icon })
      })

      document.addEventListener('click', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside)
    }
  }

  function hideTooltip(event) {
    const icon = event.currentTarget
    const tooltip = icon._tooltip

    setTimeout(() => {
      if (tooltip && !icon._tooltipVisible) {
        tooltip.remove()
        icon._tooltip = null
        document.removeEventListener('click', handleClickOutside)
        document.removeEventListener('touchstart', handleClickOutside)
      }
    }, 100)
  }

  function toggleTooltip(event) {
    event.stopPropagation()

    const icon = event.currentTarget

    if (icon._tooltip) {
      hideTooltip({ currentTarget: icon })
    } else {
      showTooltip(event)
    }
  }

  function handleClickOutside(event) {
    const tooltips = document.querySelectorAll('.product-tooltip')

    tooltips.forEach((tooltip) => {
      if (!tooltip.contains(event.target)) {
        const icon = tooltip.previousElementSibling

        if (icon && icon._tooltip) {
          hideTooltip({ currentTarget: icon })
        }
      }
    })
  }
})


// Desktop hover dropdown for header menu
document.addEventListener('DOMContentLoaded', () => {
  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  document.querySelectorAll('.header__inline-menu details').forEach(function(details) {
    var summary = details.querySelector('summary');

    if (!summary) return;
    
    function addHoverListeners() {
      details.addEventListener('mouseenter', function() {
        if (isDesktop()) details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', function() {
        if (isDesktop()) details.removeAttribute('open');
      });
    }
    function removeHoverListeners() {
      details.removeEventListener('mouseenter', function() {
        if (isDesktop()) details.setAttribute('open', '');
      });
      details.removeEventListener('mouseleave', function() {
        if (isDesktop()) details.removeAttribute('open');
      });
    }

    addHoverListeners();
    
    window.addEventListener('resize', function() {
      if (isDesktop()) {
        addHoverListeners();
      } else {
        removeHoverListeners();
      }
    });
  });
});

// # Hide specific classes on the page
document.addEventListener('DOMContentLoaded', () => {
  if (
    window.location.href.includes('/products/muscle-code-amino-capsules')
  ) {
    [
      'header__inline-menu',
    ].forEach((className) => {
      document.querySelectorAll(`.${className}`).forEach((el) => {
        el.style.display = 'none';
      });
    });
  }
})